<template>
  <div>
    <header :class="['navbar','navbar-solid']">
      <div class="container">
        <div class="home hidden-sm-and-down">
          <a href="/">
            <img v-if="$i18n.locale==='zh'" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/logo_nav.png"
                 alt="Logo" style="height: 3.5vw; margin-top: 0.5vw">
            <img v-else-if="$i18n.locale==='en'"
                 src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/logo_nav_en.png" alt="Logo"
                 style="height: 3.5vw; margin-top: 0.5vw">
          </a>
        </div>
        <div class="menus hidden-sm-and-down">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :router="true"
                   text-color="#e5ca8a"
                   background-color="rgba(6,6,30,0)"
                   active-text-color="#cba24c"
          >
            <el-menu-item index="/"><span class="nav-span">{{ $t('nav.home') }}</span></el-menu-item>
            <el-menu-item index="/game"><span class="nav-span">{{ $t('nav.game') }}</span></el-menu-item>
            <el-submenu index="/join_campus" v-show="$i18n.locale==='zh'">
              <template slot="title">
                <span class="nav-span">{{ $t('nav.joinus') }}</span>
              </template>
              <!--              <el-menu-item index="/join_campus" ><span class="nav-span">{{$t('nav.joinus_campus')}}</span></el-menu-item>-->
              <el-menu-item><span class="nav-span" @click="openNewWindow">{{ $t('nav.joinus_campus') }}</span>
              </el-menu-item>
              <el-menu-item><span class="nav-span" @click="openSocialWindow">{{ $t('nav.joinus_socail') }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="/join_social" v-show="$i18n.locale==='en'"><span
              class="nav-span">{{ $t('nav.joinus') }}</span></el-menu-item>
            <el-menu-item index="/about"><span class="nav-span">{{ $t('nav.aboutus') }}</span></el-menu-item>
            <!--            <el-menu-item index="/privacy" v-show="$i18n.locale==='en'"><span class="nav-span">{{$t('nav.privacy')}}</span></el-menu-item>-->
            <!--            <el-menu-item index="/terms" v-show="$i18n.locale==='en'"><span class="nav-span">{{$t('nav.terms')}}</span></el-menu-item>-->
          </el-menu>
        </div>
        <div class="lang hidden-sm-and-down">
          <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal"
                   text-color="#e5ca8a"
                   background-color="rgba(6,6,30,0.9)"
                   active-text-color="#cba24c"
          >
            <el-submenu index="0">
              <template slot="title">
                <span class="nav-span">{{ $t('nav.language') }}</span>
              </template>
              <el-menu-item index="1" @click="handleChangeLanguage('zh')"><span
                class="nav-span">{{ $t('nav.language_zh') }}</span></el-menu-item>
              <el-menu-item index="2" @click="handleChangeLanguage('en')"><span
                class="nav-span">{{ $t('nav.language_en') }}</span></el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </header>
    <div class="header_mobile hidden-md-and-up">
      <div class="home hidden-md-and-up">
        <a href="/">
          <img v-if="$i18n.locale==='zh'" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/logo_nav.png"
               alt="Logo">
          <img v-else-if="$i18n.locale==='en'"
               src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/logo_nav_en.png" alt="Logo">
        </a>
      </div>
      <div class="menus hidden-md-and-up">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :router="true"
                 text-color="#e5ca8a"
                 background-color="rgba(6,6,30,0)"
                 active-text-color="#cba24c">
          <el-menu-item index="/"><span class="nav-span">{{ $t('nav.home') }}</span></el-menu-item>
          <el-menu-item index="/game"><span class="nav-span">{{ $t('nav.game') }}</span></el-menu-item>
          <el-submenu index="/join_social" v-show="$i18n.locale==='zh'">
            <template slot="title">
              <span class="nav-span">{{ $t('nav.joinus') }}</span>
            </template>
            <el-menu-item><span class="nav-span" @click="openNewWindow">{{ $t('nav.joinus_campus') }}</span>
            </el-menu-item>
            <el-menu-item><span class="nav-span" @click="openSocialWindow">{{ $t('nav.joinus_socail') }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/join_social" v-show="$i18n.locale==='en'"><span
            class="nav-span">{{ $t('nav.joinus') }}</span></el-menu-item>
          <el-menu-item index="/about"><span class="nav-span">{{ $t('nav.aboutus') }}</span></el-menu-item>
          <el-menu-item index="/privacy" v-show="$i18n.locale==='en'"><span
            class="nav-span">{{ $t('nav.privacy') }}</span></el-menu-item>
          <el-menu-item index="/terms" v-show="$i18n.locale==='en'"><span class="nav-span">{{ $t('nav.terms') }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="lang hidden-md-and-up">
        <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal"
                 text-color="#e5ca8a"
                 background-color="rgba(6,6,30,0.9)"
                 active-text-color="#cba24c">
          <el-submenu index="0">
            <template slot="title">
              <span class="nav-span">{{ $t('nav.language') }}</span>
            </template>
            <el-menu-item index="1" @click="handleChangeLanguage('zh')"><span
              class="nav-span">{{ $t('nav.language_zh') }}</span></el-menu-item>
            <el-menu-item index="2" @click="handleChangeLanguage('en')"><span
              class="nav-span">{{ $t('nav.language_en') }}</span></el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>


</template>
<script>
export default {
  props: ['isHome'], // 如果是主页的navbar，则添加透明滚动渐变效果
  data() {
    return {
      scrolled: false, // 是否有滚动
      language: 'zh',
      activeIndex2: '1'
    };
  },
  computed: {
    activeIndex() {
      return `/${this.$route.path.split('/')[1]}` || '/';
    }
  },
  methods: {
    openNewWindow() {
      window.open('https://app.mokahr.com/su/coxikq');
    },
    openSocialWindow() {
      window.open('https://app.mokahr.com/su/lpkjke');
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0; // 滚动事件的回调
    },
    handleCommand(command) { // 小屏状态时的下来菜单点击回调
      this.$router.push(command);
    },
    //切换中英文
    handleChangeLanguage(type) {
      this.language = type;
      this.$i18n.locale = type;
      window.localStorage.setItem('so_lang', type);
      this.$router.push('/');
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll); // 监听滚动事件
  },
};
</script>


<style lang="less" scoped>
@import 'element-ui/lib/theme-chalk/display.css';
@import url('../assets/style/colors.less');

// 菜单栏
.navbar {
  background-color: @lanmu;

  .el-dropdown {
    float: right;
    color: white;
    font-size: 24px;
    font-weight: 700;
    padding-top: 10px;
    user-select: none;
    cursor: pointer;
  }


}


header {
  height: 4.5vw;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  line-height: 60px;
  z-index: 1000;

  .home {
    float: left;
  }

  .menus {
    float: right;
    height: 100%;

    .el-menu {
      margin-right: 11vw;
    }

    .el-menu-item {
      width: 11vw;
    }

    .el-submenu {
      width: 11vw;
    }
  }

  .lang {
    position: absolute;
    right: 0;
    top: 0;

    .el-menu {
      margin-right: 0vw;
    }

    .el-menu-item {
      width: 11vw;
    }

    .el-submenu {
      width: 11vw;
    }
  }
}

.header_mobile {
  background-color: @lanmu_no;
  height: 17vw;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;

  .home {
    text-align: left;
    margin-left: 10vw;

    img {
      margin-top: 0.5vw;
      height: 7.5vw;
    }
  }

  .menus {
    .el-menu {
      width: 90%;
      margin: 0 auto;
      display: flex;
      overflow-x: auto;
    }

    .el-menu-item {
      width: 22vw;
      height: 8vw;
      margin-right: 20px;
    }

    .el-submenu {
      width: 22vw;
      height: 8vw;
    }
  }

  .el-menu, .el-submenu__title, .el-menu-item {
    padding: 0 0;
  }

  .lang {
    position: absolute;
    right: 0;
    top: 1vw;

    .el-menu {
      margin-right: 0vw;
    }

    .el-menu-item {
      width: 22vw;
      height: 8vw;
    }

    .el-submenu {
      width: 22vw;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Nav.vue